import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import Style from './Icon.module.scss';

const renderGraphic = (icon, igStyle) => {
  switch (icon) {
    case 'add':
      return (
        <g>
          <path d="M19 13h-6v6h-2v-6h-6v-2h6v-6h2v6h6v2z" />
        </g>
      );
    case 'add-thin':
      return (
        <g>
          <path d="M13.083,10.902l10.902,0l0,2.181l-10.902,0l0,10.902l-2.181,0l0,-10.902l-10.902,0l0,-2.181l10.902,0l0,-10.902l2.181,0l0,10.902Z" />
        </g>
      );
    case 'apple':
      return (
        <g>
          <path d="M18.685,12.678c-0.027,-2.949 2.408,-4.364 2.519,-4.433c-1.371,-2.005 -3.503,-2.28 -4.264,-2.312c-1.814,-0.183 -3.541,1.068 -4.46,1.068c-0.919,0 -2.341,-1.041 -3.845,-1.012c-1.979,0.029 -3.802,1.15 -4.821,2.921c-2.055,3.564 -0.524,8.847 1.476,11.74c0.979,1.414 2.145,3.008 3.679,2.949c1.477,-0.059 2.035,-0.955 3.818,-0.955c1.783,0 2.285,0.955 3.846,0.927c1.588,-0.031 2.595,-1.445 3.567,-2.864c1.122,-1.642 1.587,-3.231 1.613,-3.314c-0.035,-0.015 -3.096,-1.188 -3.128,-4.715" />
          <path
            id="path190"
            d="M15.752,4.02c0.813,-0.985 1.362,-2.356 1.211,-3.721c-1.172,0.047 -2.59,0.781 -3.432,1.766c-0.753,0.871 -1.414,2.266 -1.235,3.604c1.307,0.102 2.642,-0.665 3.456,-1.649"
          />
        </g>
      );
    case 'article':
      return (
        <g
          id="Permutations"
          stroke="none"
          strokeWidth="1"
          fill="none"
          fillRule="evenodd"
          strokeLinecap="square"
        >
          <g id="1440_Home" transform="translate(-84.000000, -2818.000000)" stroke="#FFFFFF">
            <g id="Links" transform="translate(66.000000, 2734.000000)">
              <g id="Group-5">
                <g id="Group-4" transform="translate(0.000000, 60.000000)">
                  <g id="Group">
                    <g id="Icon/Article" transform="translate(17.000000, 23.000000)">
                      <line
                        x1="1.50593822"
                        y1="2.47348735"
                        x2="13.514349"
                        y2="2.47348735"
                        id="Line"
                      />
                      <line
                        x1="1.50593822"
                        y1="5.82449578"
                        x2="9.76434947"
                        y2="5.82449578"
                        id="Line-Copy"
                      />
                      <line
                        x1="1.50593822"
                        y1="9.17550422"
                        x2="13.514349"
                        y2="9.17550422"
                        id="Line-Copy-2"
                      />
                      <line
                        x1="1.50593822"
                        y1="12.5265127"
                        x2="9.76434947"
                        y2="12.5265127"
                        id="Line-Copy-3"
                      />
                    </g>
                  </g>
                </g>
              </g>
            </g>
          </g>
        </g>
      );
    case 'arrow-back':
      return (
        <g>
          <path d="M20 11h-12.17l5.59-5.59-1.42-1.41-8 8 8 8 1.41-1.41-5.58-5.59h12.17v-2z" />
        </g> // eslint-disable-line
      );
    case 'arrow-drop-up':
      return (
        <g>
          <path d="M7 14l5-5 5 5z" />
        </g> // eslint-disable-line
      );
    case 'arrow-forward':
      return (
        <g>
          <path d="M12 4l-1.41 1.41 5.58 5.59h-12.17v2h12.17l-5.58 5.59 1.41 1.41 8-8z" />
        </g> // eslint-disable-line
      );
    case 'arrow-left':
      return (
        <g>
          <path d="M6.342,12.192l11.303,11.303l0.333,-0.334l-11.303,-11.302l11.303,-11.303l-0.333,-0.333l-11.303,11.303l-0.002,-0.003l-0.334,0.333l0.003,0.003l-0.003,0.002l0.334,0.333l0.002,-0.002Z" />
        </g> // eslint-disable-line
      );
    case 'arrow-right':
      return (
        <g>
          <path d="M17.642,11.526l-11.303,-11.303l-0.333,0.333l11.303,11.303l-11.303,11.302l0.333,0.334l11.303,-11.303l0.002,0.002l0.334,-0.333l-0.003,-0.002l0.003,-0.003l-0.334,-0.333l-0.002,0.003Z" />
        </g> // eslint-disable-line
      );
    case 'ios-arrow-right':
      return (
        <g
          xmlns="http://www.w3.org/2000/svg"
          id="_x33_20_x5F_See-All-Grid_x5F_Cast-Popup"
          transform="translate(-272.000000, -117.000000)"
        >
          <g id="Arrows" transform="translate(15.000000, 109.000000)">
            <g
              id="Icons_x2F_White_x2F_Back-Arrow"
              transform="translate(266.000000, 24.000000) scale(-1, 1) translate(-266.000000, -24.000000) translate(242.000000, 0.000000)"
            >
              <polygon
                id="iOS-Back-Arrow"
                className="st0"
                points="32.8,37.2 19.7,24 32.8,10.8 30,8 14,24 30,40     "
              />
            </g>
          </g>
        </g>
      );
    case 'ios-arrow-left':
      return (
        <g
          xmlns="http://www.w3.org/2000/svg"
          id="_x33_20_x5F_See-All-Grid_x5F_Cast-Popup"
          transform="translate(-29.000000, -117.000000)"
        >
          <g id="Arrows" transform="translate(15.000000, 109.000000)">
            <g id="Icons_x2F_White_x2F_Back-Arrow">
              <polygon
                id="iOS-Back-Arrow"
                className="st0"
                points="32.8,37.2 19.7,24 32.8,10.8 30,8 14,24 30,40     "
              />
            </g>
          </g>
        </g>
      );
    case 'auth-key':
      return (
        <g>
          <path d="M21.816,8.958l-11.295,0c-1.006,-1.759 -2.785,-2.958 -4.874,-2.958c-3.094,0 -5.647,2.718 -5.647,5.995c0,3.278 2.553,5.996 5.647,5.996c2.089,0 3.946,-1.279 4.951,-3.118l2.167,0l1.779,-1.918l1.392,1.439l1.393,-1.439l1.392,1.519l1.393,-1.519l1.392,1.439l2.476,-2.638l0,-0.32l-2.166,-2.478Zm-18.722,4.716c-0.851,0 -1.547,-0.719 -1.547,-1.679c0,-0.959 0.696,-1.678 1.547,-1.678c0.851,0 1.548,0.719 1.548,1.678c0.077,0.96 -0.619,1.679 -1.548,1.679Z" />
        </g> // eslint-disable-line
      );
    case 'bell':
      return (
        <g fill="none" fillRule="evenodd">
          <path
            stroke="#FFF"
            strokeWidth="2"
            d="M1.032 18.998c5.988.002 11.975.002 17.963 0-.004-1.236-.008-3.21.004-3.534.007-.194-.037-.361-.124-.5-.124-.2-.319-.346-.526-.461-.574-.32-1.59-.564-1.59-.564s-.334-.08-.743-.143L16 12.985s-.04-2.523 0-4.505c.022-1.077-.249-1.976-.778-2.704-.629-.864-1.587-1.496-3.308-2.944-.064-.344-.138-.998-.61-1.44-.264-.247-.666-.391-1.235-.391-.47 0-.816.142-1.068.365-.485.427-.675 1.064-.815 1.461-.259.733-.593 1.001-.769 1.082-1.101.505-1.968 1.12-2.553 1.924C4.33 6.569 4.043 7.46 4 8.54c-.067 1.622-.018 4.411-.018 4.411s.006.325.019.816c-.42.078-.758.167-.758.167s-.953.253-1.573.58c-.346.182-.596.388-.629.761-.038.45-.022 2.48-.008 3.723z"
            transform="translate(2.978 .116)"
          />
          <path
            fill="#FFF"
            d="M12.986 21s.007.221 0 .504c-.026.964-1.48 2.448-2.983 2.448-1.503 0-3.07-1.205-3-2.445.014-.271 0-.507 0-.507"
            transform="translate(2.978 .116)"
          />
        </g>
      );
    case 'bell-filled':
      return (
        <g fill="#FFF" fillRule="evenodd">
          <path
            stroke="#FFF"
            strokeWidth="2"
            d="M1.032 18.998c5.988.002 11.975.002 17.963 0-.004-1.236-.008-3.21.004-3.534.007-.194-.037-.361-.124-.5-.124-.2-.319-.346-.526-.461-.574-.32-1.59-.564-1.59-.564s-.334-.08-.743-.143L16 12.985s-.04-2.523 0-4.505c.022-1.077-.249-1.976-.778-2.704-.629-.864-1.587-1.496-3.308-2.944-.064-.344-.138-.998-.61-1.44-.264-.247-.666-.391-1.235-.391-.47 0-.816.142-1.068.365-.485.427-.675 1.064-.815 1.461-.259.733-.593 1.001-.769 1.082-1.101.505-1.968 1.12-2.553 1.924C4.33 6.569 4.043 7.46 4 8.54c-.067 1.622-.018 4.411-.018 4.411s.006.325.019.816c-.42.078-.758.167-.758.167s-.953.253-1.573.58c-.346.182-.596.388-.629.761-.038.45-.022 2.48-.008 3.723z"
            transform="rotate(-16 22.576 2.965)"
          />
          <path
            d="M12.986 21s.007.221 0 .504c-.026.964-1.48 2.448-2.983 2.448-1.503 0-3.07-1.205-3-2.445.014-.271 0-.507 0-.507"
            transform="rotate(-16 22.576 2.965)"
          />
        </g>
      );
    case 'blocked':
      return (
        <g>
          <circle cx="10.5" cy="10.5" r="10.5" stroke="#F00" />
          <path fill="#F00" d="M17.571 2.722l.707.707-14.85 14.85-.706-.708z" />
        </g>
      );
    case 'cancel':
      return (
        <g>
          <path d="M12 2c-5.53 0-10 4.47-10 10s4.47 10 10 10 10-4.47 10-10-4.47-10-10-10zm5 13.59l-1.41 1.41-3.59-3.59-3.59 3.59-1.41-1.41 3.59-3.59-3.59-3.59 1.41-1.41 3.59 3.59 3.59-3.59 1.41 1.41-3.59 3.59 3.59 3.59z" />
        </g> // eslint-disable-line
      );
    case 'carousel-arrow-left':
      return (
        <g fill="none" fillRule="evenodd">
          <g transform="translate(4 1.32)">
            <filter
              fill="#000"
              width="139.7%"
              height="139.7%"
              x="-19.8%"
              y="-14.2%"
              filterUnits="objectBoundingBox"
            >
              <feOffset dy="2" in="SourceAlpha" result="shadowOffsetOuter1" />
              <feGaussianBlur in="shadowOffsetOuter1" result="shadowBlurOuter1" stdDeviation="2" />
              <feColorMatrix
                in="shadowBlurOuter1"
                values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.5 0"
              />
            </filter>
            <circle fill="#FFF" cx="18" cy="18" r="17.634" />
          </g>
          <path
            stroke="#000"
            strokeWidth="2"
            d="M17.345 19.32l6.904-6.905.406.406-6.499 6.5 6.5 6.498-.407.407-6.904-6.905z"
          />
        </g>
      );
    case 'carousel-arrow-right':
      return (
        <g fill="none" fillRule="evenodd">
          <g transform="translate(3 2)">
            <filter
              fill="#000"
              width="139.7%"
              height="139.7%"
              x="-19.8%"
              y="-14.2%"
              filterUnits="objectBoundingBox"
            >
              <feOffset dy="2" in="SourceAlpha" result="shadowOffsetOuter1" />
              <feGaussianBlur in="shadowOffsetOuter1" result="shadowBlurOuter1" stdDeviation="2" />
              <feColorMatrix
                in="shadowBlurOuter1"
                values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.5 0"
              />
            </filter>
            <circle fill="#FFF" cx="18" cy="18" r="17.634" />
          </g>
          <path
            stroke="#000"
            strokeWidth="2"
            d="M26.655 20l-6.904 6.906-.406-.407L25.844 20l-6.5-6.5.407-.406L26.655 20V20z"
          />
        </g>
      );
    case 'checkmark':
      return (
        <g>
          <path d="M4.649,8.807l-4.367,4.311l9.021,10.173l14.473,-16.283l-4.411,-4.256l-10.122,11.192l-4.594,-5.137Z" />
        </g> // eslint-disable-line
      );
    case 'checkmark-circle':
      return (
        <g fillRule="nonzero" fill="none">
          <path
            stroke="#FFF"
            strokeWidth="2.7"
            d="M68.878 35.486c0 18.613-15.09 33.702-33.703 33.702-18.613 0-33.702-15.089-33.702-33.702S16.562 1.784 35.175 1.784c18.614 0 33.703 15.089 33.703 33.702z"
          />
          <path
            fill="#FFF"
            d="M27.941 50.2l1.435 1.434 1.435-1.435 23.196-23.196 1.436-1.435-2.87-2.87-1.436 1.435-23.196 23.196h2.87L19.213 35.73l-1.435-1.435-2.87 2.87 1.435 1.435z"
          />
        </g>
      );
    case 'checkmark-thin':
      return (
        <g>
          <path
            fill="none"
            fillRule="evenodd"
            stroke="#FFF"
            strokeLinecap="round"
            strokeLinejoin="round"
            strokeWidth="1.3"
            d="M2 10.464l5.667 5.465L19 5"
          />
        </g>
      );
    case 'chevron-down':
      return (
        <path
          fill="#FFF"
          d="M5 6L10 1.495 8.714 0 4.997 3.407 1.286 0 0 1.495z"
          transform="translate(.725)"
        />
      );
    case 'circle-arrow-down':
      return (
        <g fill="none" fillRule="evenodd">
          <path
            fill="#FFF"
            fillRule="nonzero"
            d="M9 12.375l4.5-4.224-1.158-1.401-3.344 3.194-3.34-3.194L4.5 8.151z"
          />
          <circle cx="9" cy="9" r="9" />
          <circle cx="9" cy="9" r="8" stroke="#FFF" strokeWidth="2" opacity=".65" />
        </g> // eslint-disable-line
      );
    case 'circle-arrow-up':
      return (
        <g fill="none" fillRule="evenodd">
          <path
            fill="#FFF"
            fillRule="nonzero"
            d="M9 5.625L4.5 9.849l1.158 1.401 3.344-3.194 3.34 3.194L13.5 9.849z"
          />
          <circle cx="9" cy="9" r="9" />
          <circle cx="9" cy="9" r="8" stroke="#FFF" strokeWidth="2" opacity=".65" />
        </g> // eslint-disable-line
      );
    case 'circle-plus':
      return (
        <g
          xmlns="http://www.w3.org/2000/svg"
          fill="none"
          fillRule="evenodd"
          transform="translate(1 1)"
        >
          <circle cx="11" cy="11" r="11" stroke="#FFF" strokeWidth="2" />
          <path fill="#FFF" d="M10 5h2v12h-2z" />
          <path fill="#FFF" d="M17 10v2H5v-2z" />
        </g>
      );
    case 'circle-plus-checked':
      return (
        <path
          xmlns="http://www.w3.org/2000/svg"
          fill="#FFF"
          fillRule="evenodd"
          d="M12.602 0c6.96 0 12.602 5.642 12.602 12.602s-5.642 12.602-12.602 12.602S0 19.562 0 12.602 5.642 0 12.602 0zm5.604 7.34l-7.14 7.393-3.306-3.192-1.459 1.51 3.306 3.193-.155.161 1.51 1.46 8.755-9.066-1.511-1.459z"
        />
      );
    case 'circle-plus-hover':
      return (
        <>
          <defs>
            <filter
              id="a"
              width="175%"
              height="175%"
              x="-37.5%"
              y="-37.5%"
              filterUnits="objectBoundingBox"
            >
              <feOffset dy="1" in="SourceAlpha" result="shadowOffsetOuter1" />
              <feGaussianBlur in="shadowOffsetOuter1" result="shadowBlurOuter1" stdDeviation="2" />
              <feColorMatrix
                in="shadowBlurOuter1"
                result="shadowMatrixOuter1"
                values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.5 0"
              />
              <feMerge>
                <feMergeNode in="shadowMatrixOuter1" />
                <feMergeNode in="SourceGraphic" />
              </feMerge>
            </filter>
          </defs>
          <g fill="none" fillRule="evenodd" stroke="#FFF" transform="translate(.55 .77)">
            <circle
              cx="13.91"
              cy="13.91"
              r="12.309"
              fill="#000"
              fillOpacity=".25"
              strokeWidth="1.739"
            />
            <path
              fill="#FFF"
              strokeWidth=".927"
              d="M14.685 8.297v5.4h5.398v1.157l-5.398.004-.004 5.397h-1.156v-5.401H8.128V13.7l5.397-.005.004-5.397h1.156z"
            />
          </g>
        </>
      );
    case 'circle-plus-checked-hover':
      return (
        <>
          <defs>
            <filter
              id="a"
              width="192.3%"
              height="192.3%"
              x="-46.2%"
              y="-46.2%"
              filterUnits="objectBoundingBox"
            >
              <feOffset dy="2" in="SourceAlpha" result="shadowOffsetOuter1" />
              <feGaussianBlur in="shadowOffsetOuter1" result="shadowBlurOuter1" stdDeviation="2" />
              <feColorMatrix
                in="shadowBlurOuter1"
                result="shadowMatrixOuter1"
                values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.5 0"
              />
              <feMerge>
                <feMergeNode in="shadowMatrixOuter1" />
                <feMergeNode in="SourceGraphic" />
              </feMerge>
            </filter>
          </defs>
          <path
            fill="#FFF"
            fillRule="evenodd"
            d="M12.164 0c6.718 0 12.164 5.446 12.164 12.164s-5.446 12.164-12.164 12.164S0 18.882 0 12.164 5.446 0 12.164 0zm5.404 7.122l-6.897 7.166L7.64 11.36 6.23 12.819l4.376 4.225 1.408-1.458 7.021-7.055-1.468-1.41z"
            transform="translate(1.296 1.516)"
          />
        </>
      );
    case 'close':
      return (
        <g>
          <path d="M19 6.41l-1.41-1.41-5.59 5.59-5.59-5.59-1.41 1.41 5.59 5.59-5.59 5.59 1.41 1.41 5.59-5.59 5.59 5.59 1.41-1.41-5.59-5.59z" />
        </g> // eslint-disable-line
      );
    case 'external-link-square':
      return (
        <g fill="none" fillRule="evenodd" stroke="#FFF" strokeWidth="2">
          <g strokeLinecap="square">
            <path d="M13.125 6.25v-3.5M8.75 1.875h4.375M12.25 2.75L5.72 9.28" />
          </g>
          <path d="M13 10.432L4.563 2H1v12h12v-3.568z" />
        </g>
      );
    case 'external-link-square-alt':
      return (
        <g fillRule="evenodd" clipRule="evenodd">
          <path d="M14 4h-13v18h20v-11h1v12h-22v-20h14v1zm10 5h-1v-6.293l-11.646 11.647-.708-.708 11.647-11.646h-6.293v-1h8v8z" />
        </g>
      );
    case 'external-link-square-alt2':
      return (
        <g id="Permutations" stroke="none" strokeWidth="1" fill="none" fillRule="evenodd">
          <g
            id="1440_Home"
            transform="translate(-313.000000, -2817.000000)"
            fill="#FFFFFF"
            stroke="#FFFFFF"
            strokeWidth="0.5"
          >
            <g id="Links" transform="translate(66.000000, 2734.000000)">
              <g id="Group-5">
                <g id="Group-4" transform="translate(0.000000, 60.000000)">
                  <g id="Group-2" transform="translate(229.000000, 0.000000)">
                    <g id="Icon/LinkOut" transform="translate(17.000000, 23.000000)">
                      <path
                        d="M7.5,2.32954545 L1.77083333,2.32954545 L1.77083333,12.5568182 L12.1875,12.5568182 L12.1875,7.44318182 L12.7083333,7.44318182 L12.7083333,13.125 L1.25,13.125 L1.25,1.76136364 L7.5,1.76136364 L7.5,2.32954545 Z M13.75,5.17045455 L13.2291667,5.17045455 L13.2291667,1.59488636 L7.16354167,8.2125 L6.79479167,7.81022727 L12.8609375,1.19318182 L9.58333333,1.19318182 L9.58333333,0.625 L13.75,0.625 L13.75,5.17045455 Z"
                        id="Shape"
                      />
                    </g>
                  </g>
                </g>
              </g>
            </g>
          </g>
        </g>
      );
    case 'extension':
      return (
        <g>
          <path d="M20.5 11h-1.5v-4c0-1.1-.9-2-2-2h-4v-1.5c0-1.38-1.12-2.5-2.5-2.5s-2.5 1.12-2.5 2.5v1.5h-4c-1.1 0-1.99.9-1.99 2v3.8h1.49c1.49 0 2.7 1.21 2.7 2.7s-1.21 2.7-2.7 2.7h-1.5v3.8c0 1.1.9 2 2 2h3.8v-1.5c0-1.49 1.21-2.7 2.7-2.7 1.49 0 2.7 1.21 2.7 2.7v1.5h3.8c1.1 0 2-.9 2-2v-4h1.5c1.38 0 2.5-1.12 2.5-2.5s-1.12-2.5-2.5-2.5z" />
        </g> // eslint-disable-line
      );
    case 'facebook':
      return (
        <g>
          <path
            id="icon-fb"
            d="M30.1834292,15.0917146 C30.1834292,6.75678464 23.4266445,0 15.0917146,0 C6.75678464,0 0,6.75678464 0,15.0917146 C0,22.6244256 5.5188219,28.8679151 12.7336342,30 L12.7336342,19.4541633 L8.90175353,19.4541633 L8.90175353,15.0917146 L12.7336342,15.0917146 L12.7336342,11.7668212 C12.7336342,7.98446025 14.9867211,5.89520101 18.4339988,5.89520101 C20.0851562,5.89520101 21.8122437,6.18996106 21.8122437,6.18996106 L21.8122437,9.9039377 L19.9092139,9.9039377 C18.0344516,9.9039377 17.449795,11.0672672 17.449795,12.2607506 L17.449795,15.0917146 L21.6353877,15.0917146 L20.9662824,19.4541633 L17.449795,19.4541633 L17.449795,30 C24.6646073,28.8679151 30.1834292,22.6244256 30.1834292,15.0917146"
          />
        </g> // eslint-disable-line
      );
    case 'favorite':
      return (
        <g>
          <path d="M10.684,6.204c-3.995,-3.464 -8.083,-1.986 -8.083,2.731c0,0.358 0.052,0.739 0.158,1.141c0.528,2.004 2.313,4.37 4.965,6.799c1.206,1.097 2.473,2.126 3.795,3.08c0.556,0.402 1.122,0.791 1.697,1.166l-2.273,-0.002c0.575,-0.374 1.14,-0.761 1.696,-1.162c1.322,-0.951 2.589,-1.977 3.795,-3.072c2.69,-2.462 4.486,-4.861 4.983,-6.885c0.093,-0.373 0.139,-0.729 0.139,-1.065c0,-4.649 -4.565,-6.255 -7.97,-2.836l-1.402,1.407l-1.502,-1.302l0.002,0Zm12.978,2.731c0,6.658 -11.584,13.922 -11.584,13.922c0,0 -11.582,-7.289 -11.582,-13.922c0,-6.631 6.33,-8.834 11.584,-4.277c4.612,-4.633 11.583,-2.38 11.583,4.277l-0.001,0l0,0Z" />
        </g>
      );
    case 'favorite-filled':
      return (
        <g>
          <path d="M1.123,9.032c0,6.436 11.016,13.51 11.016,13.51c0,0 11.017,-7.05 11.017,-13.51c0,-6.459 -6.63,-8.646 -11.017,-4.151c-4.996,-4.421 -11.016,-2.284 -11.016,4.152l0,-0.001Z" />
        </g>
      );
    case 'fb-logo':
      return (
        <g>
          <path
            d="M1024,512C1024,229.2,794.8,0,512,0S0,229.2,0,512c0,255.6,187.2,467.4,432,505.8V660H302V512h130V399.2
            C432,270.9,508.4,200,625.4,200c56,0,114.6,10,114.6,10v126h-64.6c-63.6,0-83.4,39.5-83.4,80v96h142l-22.7,148H592v357.8
            C836.8,979.4,1024,767.6,1024,512z"
          />
        </g>
      );
    case 'filmstrip':
      return (
        <g fill="none" fillRule="evenodd">
          <path stroke="#FFF" strokeWidth="1.125" d="M.563 2.063h16.875v13.875H.563z" />
          <path
            fill="#FFF"
            d="M2.25 3.75H4.5v1.5H2.25zM13.5 3.75h2.25v1.5H13.5zM2.25 6.75H4.5v1.5H2.25zM13.5 6.75h2.25v1.5H13.5zM2.25 9.75H4.5v1.5H2.25zM2.25 12.75H4.5v1.5H2.25zM13.5 9.75h2.25v1.5H13.5zM13.5 12.75h2.25v1.5H13.5z"
          />
        </g>
      );
    case 'folder-open':
      return (
        <g>
          <path d="M20 6h-8l-2-2h-6c-1.1 0-1.99.9-1.99 2l-.01 12c0 1.1.9 2 2 2h16c1.1 0 2-.9 2-2v-10c0-1.1-.9-2-2-2zm0 12h-16v-10h16v10z" />
        </g> // eslint-disable-line
      );
    case 'four-squares':
      return (
        <g>
          <path d="M0.36,0.314l10.621,0l0,10.62l-10.621,0l0,-10.62Zm0,12.747l10.621,0l0,10.621l-10.621,0l0,-10.621Zm12.747,-12.747l10.621,0l0,10.62l-10.621,0l0,-10.62Zm0,12.747l10.621,0l0,10.621l-10.621,0l0,-10.621Z" />
        </g>
      );
    case 'fox-logo':
      return (
        <g>
          <path
            d="M12.313,7.559c2.397,0 4.33,2.047 4.33,4.576c0,2.529 -1.933,4.577 -4.33,4.577c-2.406,0 -4.349,-2.038 -4.349,-4.577c0,-2.529 1.943,-4.576 4.349,-4.576Zm-9.913,9.296l0,-9.468l5.46,0l0.165,2.597l-3.054,0l0,1.243l2.496,0l0,2.558l-2.496,0l0,3.07l-2.571,0Zm21.169,-0.03l-2.737,-4.886l2.5,-4.513l-2.765,0l-1.111,2.008l-1.135,-2.008l-2.817,0l2.529,4.537l-2.694,4.862l2.765,0l1.305,-2.347l1.323,2.347l2.837,0Zm-10.509,-2.814l0,-3.752c0,-0.446 -0.317,-0.825 -0.747,-0.825c-0.392,0 -0.728,0.379 -0.728,0.825l0,3.752c0,0.418 0.336,0.766 0.728,0.766c0.43,0 0.747,-0.299 0.747,-0.766Z"
            fillRule="nonzero"
          />
        </g>
      );

    case 'fox-watermark-logo':
      return (
        <g id="Network/FOXcom/White" stroke="none" strokeWidth="1" fill="none" fillRule="evenodd">
          <path
            d="M69.7841286,0.0197794645 C86.8995394,0.0197794645 100.774127,13.8943666 100.774127,31.0097775 C100.774127,48.1251883 86.8995394,62 69.7841286,62 C52.6687177,62 38.7941305,48.1251883 38.7941305,31.0097775 C38.7941305,13.8943666 52.6687177,0.0197794645 69.7841286,0.0197794645 Z M111.616282,0.000112255758 L119.145051,13.2685183 L126.674044,0.000112255758 L146.795889,0.000112255758 L129.236843,31.0538715 L146.795889,61.9998653 L126.571892,61.9998653 L119.145051,48.901639 L111.718434,61.9998653 L91.494437,61.9998653 L109.053483,31.0538715 L91.494437,0.000112255758 L111.616282,0.000112255758 Z M38.5501988,0 L39.6869006,16.9106564 L18.7669176,16.9106564 L18.7669176,25.024278 L35.8279967,25.024278 L35.8279967,41.9894907 L18.7669176,41.9894907 L18.7669176,61.9999775 L1.42108547e-14,61.9999775 L1.42108547e-14,0 L38.5501988,0 Z M69.870341,12.7650737 C67.0410469,12.7650737 64.7537235,15.364019 64.7537235,18.2680754 L64.7537235,18.2680754 L64.7476617,43.6553886 C64.7476617,46.5612411 67.0410469,48.9147953 69.8683204,48.9147953 C72.6971655,48.9147953 75.2125925,46.6351054 75.2125925,43.7294774 L75.2125925,43.7294774 L75.2125925,18.2680754 C75.2125925,15.364019 72.6971655,12.7650737 69.870341,12.7650737 Z"
            id="New-Fox-Logo"
            fill="#FFFFFF"
          />
          <path
            d="M178.770251,60.693693 C186.450423,60.693693 190.860329,57.3738765 194.130595,52.864872 L186.896368,47.711724 C184.81529,50.2387485 182.684661,51.9234315 179.067547,51.9234315 C174.211697,51.9234315 170.792781,47.8603725 170.792781,42.657675 L170.792781,42.558576 C170.792781,37.504527 174.211697,33.3919185 179.067547,33.3919185 C182.387364,33.3919185 184.666641,34.9775025 186.648621,37.4549775 L193.882848,31.855884 C190.810779,27.594627 186.252225,24.621657 179.166647,24.621657 C168.662152,24.621657 160.882881,32.549577 160.882881,42.657675 L160.882881,42.756774 C160.882881,53.1126195 168.860351,60.693693 178.770251,60.693693 Z M213.740763,60.693693 C224.443455,60.693693 232.470474,52.6171245 232.470474,42.657675 L232.470474,42.558576 C232.470474,32.5991265 224.542554,24.621657 213.839862,24.621657 C203.13717,24.621657 195.110151,32.6982255 195.110151,42.657675 L195.110151,42.756774 C195.110151,52.7162235 203.038071,60.693693 213.740763,60.693693 Z M154,51 C156.761424,51 159,53.2385763 159,56 C159,58.7614237 156.761424,61 154,61 C151.238576,61 149,58.7614237 149,56 C149,53.2385763 151.238576,51 154,51 Z M245.229716,25.31535 L253.504483,38.7432645 L261.779249,25.31535 L271.936897,25.31535 L271.936897,60 L262.373844,60 L262.373844,40.081101 L253.504483,53.657664 L253.306285,53.657664 L244.486474,40.1802 L244.486474,60 L235.072069,60 L235.072069,25.31535 L245.229716,25.31535 Z M213.740763,33.2928195 C219.042559,33.2928195 222.659673,37.6531755 222.659673,42.657675 L222.659673,42.756774 C222.659673,47.7612735 219.141658,52.0225305 213.839862,52.0225305 C208.587615,52.0225305 204.970501,47.6621745 204.970501,42.657675 L204.970501,42.558576 C204.970501,37.5540765 208.488516,33.2928195 213.740763,33.2928195 Z"
            id="COM"
            fill="#FFFFFF"
            fillRule="nonzero"
          />
        </g>
      );

    case 'google-play':
      return (
        <g>
          <path d="M22.424,13.014l-3.979,2.193l-3.625,-3.361l3.384,-3.214l4.22,2.339c0,0 0.817,0.36 0.817,0.954c0,0.677 -0.817,1.089 -0.817,1.089Zm-20.119,-12.77c0.069,-0.018 0.143,-0.031 0.227,-0.031c0.635,0 1.227,0.408 1.227,0.408l13.087,7.258l-2.899,3.158l-11.642,-10.793Zm10.764,11.75l-10.738,11.702c-0.904,-0.181 -0.754,-1.557 -0.752,-1.694l0,-20.428c0,0 -0.017,-1.112 0.705,-1.324l10.785,11.744Zm3.766,4.101l-12.94,7.133c0,0 -0.825,0.488 -1.358,0.488c-0.071,0 -0.137,-0.006 -0.199,-0.018l11.474,-10.895l3.023,3.292Z" />
        </g>
      );
    case 'info':
      return (
        <g>
          <path
            xmlns="http://www.w3.org/2000/svg"
            fill="#FFF"
            fillOpacity=".25"
            fillRule="evenodd"
            d="M12 19a7 7 0 1 1 0-14 7 7 0 0 1 0 14zm0-9.625a.875.875 0 1 0 0-1.75.875.875 0 0 0 0 1.75zm-.656 1.75v5.25h1.312v-5.25h-1.312z"
          />
        </g>
      );
    case 'info-thin':
      return (
        <>
          <defs>
            <filter
              id="a"
              width="192.3%"
              height="192.3%"
              x="-46.2%"
              y="-46.2%"
              filterUnits="objectBoundingBox"
            >
              <feColorMatrix
                in="shadowBlurOuter1"
                result="shadowMatrixOuter1"
                values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.5 0"
              />
              <feMerge>
                <feMergeNode in="shadowMatrixOuter1" />
                <feMergeNode in="SourceGraphic" />
              </feMerge>
            </filter>
          </defs>
          <g fill="none" fillRule="evenodd" transform="translate(.38 .84)">
            <circle
              cx="12.84"
              cy="12.84"
              r="11.362"
              fill="#000"
              fillOpacity=".25"
              stroke="#FFF"
              strokeWidth="1.605"
            />
            <g fill="#FFF" transform="translate(11.488 6.758)">
              <ellipse cx="1.352" cy="1.216" rx="1.352" ry="1.216" />
              <path d="M.338 4.866h2.027v7.299H.338z" />
            </g>
          </g>
        </>
      );
    case 'instagram':
      return (
        <g>
          <defs>
            <path
              id="SVGID_4_"
              d="M826.1,0H197.9C88.7,0,0,88.7,0,197.9v628.3c0,109,88.7,197.8,197.9,197.8h628.2
            c109.1,0,197.9-88.8,197.9-197.9V197.9C1024,88.7,935.2,0,826.1,0z M882.9,118.1l22.6-0.1v173.5l-173,0.5l-0.6-173.5L882.9,118.1
            z M365.9,406.9c32.8-45.4,86-75.1,146.1-75.1s113.3,29.7,146.1,75.1c4,5.5,7.5,11.3,10.8,17.2c14.7,26,23.3,56,23.3,87.9
            c0,99.4-80.9,180.2-180.3,180.2S331.6,611.4,331.6,512c0-31.9,8.6-61.8,23.3-87.9C358.4,418.2,361.9,412.4,365.9,406.9z
            M924.2,826.1c0,54.1-44.1,98.1-98.2,98.1H197.9c-54.1,0-98.1-44-98.1-98.1V406.9h152.9c-3.8,9.4-7.1,19-9.9,28.9
            c-7,24.2-10.8,49.8-10.8,76.2c0,154.4,125.6,280,280,280s280-125.6,280-280c0-26.4-3.8-51.9-10.8-76.2
            c-2.8-9.8-6.1-19.5-9.9-28.9h152.9L924.2,826.1L924.2,826.1z"
            />
          </defs>
          <clipPath id="SVGID_3_">
            <use href="#SVGID_4_" style={{ overflow: 'visible' }} />
          </clipPath>
          <rect x="-256" y="-256" style={igStyle} width="1536" height="1536" />
        </g>
      );
    case 'keyboard-arrow-down':
      return (
        <g>
          <path d="M7.41 7.84l4.59 4.58 4.59-4.58 1.41 1.41-6 6-6-6z" />
        </g> // eslint-disable-line
      );
    case 'keyboard-arrow-up':
      return (
        <g>
          <path d="M7.41 15.41l4.59-4.58 4.59 4.58 1.41-1.41-6-6-6 6z" />
        </g> // eslint-disable-line
      );
    case 'lock':
      return (
        <g>
          <path d="M19.011,11.934l0,-5.211c-0.029,-3.672 -3.148,-6.64 -6.993,-6.64c-3.845,0 -6.963,2.969 -6.99,6.64l-0.002,5.211l-1.945,0c-0.426,0 -0.777,0.335 -0.777,0.744l0,10.406c0,0.409 0.351,0.743 0.777,0.743l17.875,0c0.426,0 0.775,-0.334 0.775,-0.743l0,-10.406c0,-0.409 -0.349,-0.744 -0.775,-0.744l-1.945,0Zm-11.267,-5.211c0,0.005 0.003,0.013 0.003,0.017c0.016,-2.236 1.936,-4.056 4.272,-4.056c2.34,0 4.255,1.821 4.271,4.056c0,-0.004 0.003,-0.012 0.003,-0.017l0,5.211l-8.549,0l0,-5.211Z" />
        </g> // eslint-disable-line
      );
    case 'movie':
      return (
        <g>
          <path d="M18 4l2 4h-3l-2-4h-2l2 4h-3l-2-4H8l2 4H7L5 4H4c-1.1 0-1.99.9-1.99 2L2 18c0 1.1.9 2 2 2h16c1.1 0 2-.9 2-2V4h-4z" />
        </g> // eslint-disable-line
      );
    case 'movie-info':
      return (
        <g>
          <path d="M21 3H3c-1.1 0-2 .9-2 2v14c0 1.1.9 2 2 2h18c1.1 0 2-.9 2-2V5c0-1.1-.9-2-2-2zM5 19H3v-2h2v2zm0-4H3v-2h2v2zm0-4H3V9h2v2zm0-4H3V5h2v2zm8 10h-2v-6h2v6zm0-8h-2V7h2v2zm8 10h-2v-2h2v2zm0-4h-2v-2h2v2zm0-4h-2V9h2v2zm0-4h-2V5h2v2z" />
        </g> // eslint-disable-line
      );
    case 'notification-off':
      return (
        <g>
          <path d="M12.317,2.493c0.12,0 0.24,0 0.24,0c0.12,0.12 0.12,0.479 0.24,0.719c0,0.36 0.24,1.56 1.559,2.159c2.279,0.84 2.519,2.159 2.519,3.239l0,6.357l1.799,0.48c0.36,0.12 0.96,0.24 1.2,0.36c0,0.36 0,1.199 0,1.919l-7.557,0l-7.557,0c0,-0.84 0,-1.44 0,-1.919c0.36,-0.12 0.84,-0.36 1.2,-0.36l1.799,-0.48l0,-1.919c0,0 0,-2.759 0,-4.318c0,-1.32 0.48,-2.399 2.639,-3.359c0.96,-0.479 1.319,-1.319 1.559,-1.919c-0.12,-0.24 0,-0.839 0.24,-0.959l0.12,0m-7.916,13.434m7.916,-15.833c-2.639,0 -2.759,2.878 -3.118,2.998c-2.519,1.2 -3.839,2.879 -3.959,5.518c-0.12,1.679 0,4.438 0,4.438c0,0 -1.079,0.24 -1.799,0.72c-0.72,0.359 -1.079,0.839 -1.199,1.559c0,0.72 0,4.798 0,4.798l19.911,0c0,0 0,-4.078 0,-4.438c0,-0.96 -0.48,-1.44 -1.2,-1.919c-0.719,-0.36 -1.799,-0.72 -1.799,-0.72c0,0 0,-2.519 0,-4.438c0,-2.759 -1.439,-4.558 -3.958,-5.518c-0.24,-0.12 0,-2.998 -2.879,-2.998Z" />
          <path d="M15.196,21.084c0,0 0,0.24 0,0.48c0,0.96 -1.44,2.399 -2.999,2.399c-1.559,0 -3.118,-1.199 -2.998,-2.399c0,-0.24 0,-0.48 0,-0.48" />
        </g>
      );
    case 'notification-on':
      return (
        <g>
          <path d="M5.216,12.993c0,0 0,-2.879 0,-4.438c0.12,-2.639 1.559,-4.318 3.958,-5.517c0.36,-0.12 0.48,-2.999 3.119,-2.999c2.879,0 2.759,2.879 2.879,2.999c2.519,0.959 4.078,2.758 3.958,5.517c0,1.919 0,4.438 0,4.438c0,0 1.199,0.24 1.799,0.72c0.72,0.36 1.2,0.959 1.2,1.919c0,0.48 0,4.438 0,4.438c0,0 -0.36,0 -0.96,0c-6.117,0 -12.115,0 -18.232,0c-0.6,0 -0.839,0 -0.839,0c0,0 0,-4.078 0,-4.798c0.12,-0.719 0.479,-1.199 1.199,-1.559c0.84,-0.48 1.919,-0.72 1.919,-0.72Z" />
          <path d="M15.172,21.03c0,0 0,0.24 0,0.479c0,0.96 -1.44,2.399 -2.999,2.399c-1.559,0 -3.119,-1.199 -2.999,-2.399c0,-0.239 0,-0.479 0,-0.479" />
        </g>
      );
    case 'edit-icon':
      return (
        <g>
          <path
            d="M17.456058,5.91891193 L19.267767,4.10710678 C20.2104357,3.16061199 20.2409263,2.17220389 19.3855417,1.29581982 L18.7047254,0.594712568 C17.8493408,-0.264143816 16.8118716,-0.15537726 15.8692029,0.773589849 L14.0951402,2.54613078 L17.456058,5.91891193 Z M5.44370412,17.9355005 L16.7490401,6.62724495 L16.7490401,6.62724495 L13.3743541,3.25561154 L2.06525646,14.5668948 C1.85756188,14.7746295 1.69817751,15.0255655 1.59843283,15.3018656 L0.0278603893,19.6524669 C-0.0190221021,19.7823348 0.0482509052,19.9256194 0.178118857,19.9725018 C0.23290799,19.9922808 0.292884023,19.9923069 0.347690376,19.9725757 L4.70677405,18.4032346 C4.98385771,18.30348 5.23549275,18.1437657 5.44370412,17.9355005 Z"
            id="Edit"
          />
        </g>
      );
    case 'play-button':
      return (
        <g>
          <circle
            cx="12.041"
            cy="12.041"
            r="11.041"
            style={{ fill: '#000', fillOpacity: '0', stroke: '#fff', strokeWidth: '2px' }}
          />
          <g>
            <path d="M17.099,12.444l-7.656,4.352c-0.341,0.194 -0.767,-0.048 -0.767,-0.436l0,-8.703c0,-0.388 0.426,-0.631 0.767,-0.437l7.656,4.352c0.341,0.194 0.341,0.679 0,0.872" />
            <path
              d="M17.099,12.444l-7.656,4.352c-0.341,0.194 -0.767,-0.048 -0.767,-0.436l0,-8.703c0,-0.388 0.426,-0.631 0.767,-0.437l7.656,4.352c0.341,0.194 0.341,0.679 0,0.872Z"
              style={{ fill: 'none', stroke: '#fff', strokeWidth: '0.14px' }}
            />
          </g>
        </g>
      );
    case 'play-button-thin':
      return (
        <g xmlns="http://www.w3.org/2000/svg" fill="none" fillRule="evenodd">
          <path d="M7.25 7h24v24h-24z" />
          <circle cx="19" cy="19" r="17" stroke="#FFF" strokeWidth="2" />
          <path fill="#FFF" d="M15.25 12v14l11-7z" />
        </g>
      );
    case 'play-rectangle':
      return (
        <g>
          <path id="Rectangle-3" d="M4.966,0.958l17.087,10.806l-17.087,10.693l0,-21.499Z" />
        </g>
      );
    case 'play-arrow':
      return (
        <g>
          <path fill="#FFF" fillRule="evenodd" d="M0 0v14l11-7z" />
        </g>
      );
    case 'phone':
      return (
        <g>
          <path d="M16.197 19.108v.7a2.7 2.7 0 0 1-2.7 2.7h-9.9a2.7 2.7 0 0 1-2.7-2.7v-16.2a2.7 2.7 0 0 1 2.7-2.7h9.9a2.7 2.7 0 0 1 2.7 2.7v15.5zm-2.7-2v-13.5h-9.9v13.5h9.9zm-4.95 4.05a1.35 1.35 0 1 0 0-2.7 1.35 1.35 0 0 0 0 2.7z" />
        </g>
      );
    case 'remove':
      return (
        <g>
          <path d="M19 13h-14v-2h14v2z" />
        </g>
      );
    case 'restart':
      return (
        <g>
          <path
            d="M9.977,11.256l4.636,-3.873l0,7.746l-4.636,-3.873Zm-3.706,0l4.636,-3.884l-0.001,1.294l-3.119,2.597l3.133,2.586l-0.013,1.291l-4.636,-3.884l0,0Z"
            style={{ fill: '#fff' }}
          />
          <circle
            cx="11.033"
            cy="11.033"
            r="10.533"
            style={{ fill: 'none', stroke: '#fff', strokeWidth: '1px' }}
          />
        </g>
      );
    case 'restart-double':
      return (
        <g>
          <path d="M10.675,12.002l13.354,-11.955l0,23.91l-13.354,-11.955Zm-10.675,0l13.354,-11.987l-0.002,3.996l-8.983,8.009l9.023,7.982l-0.038,3.986l-13.354,-11.986Z" />
        </g>
      );
    case 'search':
      return (
        <g>
          <path d="M10,-2.84217094e-14 C15.5228475,-2.84217094e-14 20,4.4771525 20,10 C20,12.3985785 19.1555311,14.5999207 17.7476871,16.3229329 L23.7022045,22.2662514 C24.098788,22.6621511 24.0993423,23.3045856 23.7034426,23.7011691 C23.7030302,23.7015821 23.7026176,23.7019948 23.7022045,23.7024071 C23.3047355,24.0991909 22.6610374,24.0991909 22.2635684,23.7024071 L16.3099413,17.7582842 C14.5888617,19.1597677 12.3925543,20 10,20 C4.4771525,20 0,15.5228475 0,10 C0,4.4771525 4.4771525,-2.84217094e-14 10,-2.84217094e-14 Z M10,1.86440678 C5.50683593,1.86440678 1.86440678,5.50683593 1.86440678,10 C1.86440678,14.4931641 5.50683593,18.1355932 10,18.1355932 C14.4931641,18.1355932 18.1355932,14.4931641 18.1355932,10 C18.1355932,5.50683593 14.4931641,1.86440678 10,1.86440678 Z" />
        </g> // eslint-disable-line
      );
    case 'serif-arrow-right':
      return (
        <g>
          <path d="M23.121,11.352l-7.193,-7.26c-0.779,-0.788 -2.044,-0.788 -2.825,0c-0.78,0.787 -0.78,2.064 0,2.851l3.782,3.817l-14.392,0c-1.103,0 -1.998,0.903 -1.998,2.016c0,1.114 0.895,2.017 1.998,2.017l14.391,0l-3.783,3.818c-0.779,0.787 -0.779,2.064 0,2.851c0.39,0.395 0.902,0.591 1.414,0.591c0.512,0 1.023,-0.196 1.412,-0.591l7.192,-7.26c0.782,-0.786 0.782,-2.063 0.002,-2.85Z" />
        </g> // eslint-disable-line
      );
    case 'settings':
      return (
        <g>
          <path d="M19.43 12.98c.04-.32.07-.64.07-.98s-.03-.66-.07-.98l2.11-1.65c.19-.15.24-.42.12-.64l-2-3.46c-.12-.22-.39-.3-.61-.22l-2.49 1c-.52-.4-1.08-.73-1.69-.98l-.38-2.65c-.03-.24-.24-.42-.49-.42h-4c-.25 0-.46.18-.49.42l-.38 2.65c-.61.25-1.17.59-1.69.98l-2.49-1c-.23-.09-.49 0-.61.22l-2 3.46c-.13.22-.07.49.12.64l2.11 1.65c-.04.32-.07.65-.07.98s.03.66.07.98l-2.11 1.65c-.19.15-.24.42-.12.64l2 3.46c.12.22.39.3.61.22l2.49-1c.52.4 1.08.73 1.69.98l.38 2.65c.03.24.24.42.49.42h4c.25 0 .46-.18.49-.42l.38-2.65c.61-.25 1.17-.59 1.69-.98l2.49 1c.23.09.49 0 .61-.22l2-3.46c.12-.22.07-.49-.12-.64l-2.11-1.65zm-7.43 2.52c-1.93 0-3.5-1.57-3.5-3.5s1.57-3.5 3.5-3.5 3.5 1.57 3.5 3.5-1.57 3.5-3.5 3.5z" />
        </g> // eslint-disable-line
      );
    case 'share':
      return (
        <g fill="none" fillRule="evenodd">
          <path
            stroke="#FEFEFE"
            strokeWidth="1.75"
            d="M11.138 10.643h2.314c1.284 0 2.326 1.103 2.326 2.464v7.38c0 1.36-1.042 2.464-2.326 2.464H3.376c-1.284 0-2.326-1.103-2.326-2.464v-7.38c0-1.36 1.042-2.464 2.326-2.464h2.387"
          />
          <path
            stroke="#FEFEFE"
            strokeLinecap="round"
            strokeWidth="2"
            d="M8.414 2.565L8.414 15.547"
          />
          <path
            fill="#FEFEFE"
            d="M12.157 7.349L13.841 5.789 8.414 0 2.987 5.789 4.671 7.349 8.275 3.524 8.414 3.674 8.555 3.524z"
          />
        </g>
      );
    case 'slideshow':
      return (
        <g>
          <path d="M10 8v8l5-4-5-4zm9-5h-14c-1.1 0-2 .9-2 2v14c0 1.1.9 2 2 2h14c1.1 0 2-.9 2-2v-14c0-1.1-.9-2-2-2zm0 16h-14v-14h14v14z" />
        </g> // eslint-disable-line
      );
    case 'star':
      return (
        <g>
          <path d="M12 17.27L18.18 21l-1.64-7.03L22 9.24l-7.19-.61L12 2 9.19 8.63 2 9.24l5.46 4.73L5.82 21z" />
        </g> // eslint-disable-line
      );
    case 'store-tag':
      return (
        <g>
          <path d="M11.766 3.165l-9.148 9.149 7.3 7.3 9.148-9.149.003-5.082-2.22-2.221-5.083.003zm6.868-.835L20.91.054l1.309 1.31-2.276 2.275.978.977-.004 6.616-11 11L0 12.313l11-11 6.615-.003 1.02 1.02z" />
          <path d="M11.821 10.39a2.862 2.862 0 1 1 4.048-4.047 2.862 2.862 0 0 1-4.048 4.048zm1.309-1.308a1.011 1.011 0 1 0 1.43-1.43 1.011 1.011 0 0 0-1.43 1.43z" />
        </g>
      );
    case 'trailer':
      return (
        <g>
          <path
            d="M24,0 L24,24 L0,24 L0,0 L24,0 Z M22.1988,1.8 L1.8,1.8 L1.8,22.1988 L22.1988,22.1988 L22.1988,1.8 Z M6.7092,18 L6.7092,20.4 L3.6,20.4 L3.6,18 L6.7092,18 Z M20.4,18 L20.4,20.4 L17.2896,20.4 L17.2896,18 L20.4,18 Z M6.7092,13.2 L6.7092,15.6 L3.6,15.6 L3.6,13.2 L6.7092,13.2 Z M20.4,13.2 L20.4,15.6 L17.2896,15.6 L17.2896,13.2 L20.4,13.2 Z M6.7092,8.4 L6.7092,10.8 L3.6,10.8 L3.6,8.4 L6.7092,8.4 Z M20.4,8.4 L20.4,10.8 L17.2896,10.8 L17.2896,8.4 L20.4,8.4 Z M6.7092,3.6 L6.7092,6 L3.6,6 L3.6,3.6 L6.7092,3.6 Z M20.4,3.6 L20.4,6 L17.2896,6 L17.2896,3.6 L20.4,3.6 Z"
            id="Trailer"
            fill="#FFFFFF"
          />
        </g>
      );
    case 'tv':
      return (
        <g>
          <path d="M21 3h-18c-1.1 0-2 .9-2 2v12c0 1.1.9 2 2 2h5v2h8v-2h5c1.1 0 1.99-.9 1.99-2l.01-12c0-1.1-.9-2-2-2zm0 14h-18v-12h18v12z" />
        </g>
      );
    case 'tv-options-input-settings':
      return (
        <g>
          <path d="M7.17 13.63l1 1.73c.06.11.19.15.31.11l1.24-.5c.26.2.54.37.85.49l.19 1.32c.01.13.12.22.24.22h2c.12 0 .23-.09.25-.21l.19-1.32c.3-.13.59-.29.84-.49l1.25.5c.11.04.24 0 .31-.11l1-1.73c.06-.11.03-.24-.06-.32l-1.06-.83c.02-.16.04-.32.04-.49s-.01-.33-.04-.49l1.06-.83c.09-.08.12-.21.06-.32l-1-1.73c-.06-.11-.19-.15-.31-.11l-1.24.5c-.26-.2-.54-.37-.84-.49l-.19-1.32c-.03-.12-.14-.21-.26-.21h-2c-.12 0-.23.09-.25.21l-.19 1.32c-.3.13-.59.29-.85.49l-1.24-.5c-.11-.04-.24 0-.31.11l-1 1.73c-.06.11-.04.24.06.32l1.06.83c-.02.16-.03.32-.03.49s.01.33.04.49l-1.06.83c-.1.07-.12.21-.06.31zm4.83-3.63c1.1 0 2 .9 2 2s-.9 2-2 2-2-.9-2-2 .9-2 2-2zm9-7h-18c-1.1 0-2 .9-2 2v14c0 1.1.9 2 2 2h18c1.1 0 2-.9 2-2v-14c0-1.1-.9-2-2-2zm0 16.01h-18v-14.02h18v14.02z" />
        </g> // eslint-disable-line
      );
    case 'twitter':
      return (
        <g>
          <path d="M7.549,19.541c9.068,0 14.03,-7.52 14.03,-14.031c0,-0.211 0,-0.423 -0.009,-0.634c0.962,-0.693 1.798,-1.568 2.462,-2.558c-0.885,0.394 -1.837,0.654 -2.837,0.779c1.019,-0.606 1.798,-1.578 2.173,-2.732c-0.952,0.568 -2.01,0.972 -3.135,1.193c-0.904,-0.962 -2.183,-1.558 -3.596,-1.558c-2.722,0 -4.934,2.212 -4.934,4.933c0,0.385 0.048,0.76 0.125,1.125c-4.096,-0.202 -7.731,-2.173 -10.164,-5.154c-0.423,0.731 -0.664,1.577 -0.664,2.481c0,1.712 0.875,3.222 2.193,4.106c-0.808,-0.029 -1.568,-0.25 -2.231,-0.615c0,0.019 0,0.038 0,0.067c0,2.385 1.702,4.385 3.952,4.837c-0.413,0.116 -0.846,0.173 -1.298,0.173c-0.318,0 -0.625,-0.029 -0.923,-0.086c0.625,1.962 2.452,3.385 4.606,3.423c-1.693,1.327 -3.818,2.116 -6.126,2.116c-0.394,0 -0.788,-0.019 -1.173,-0.067c2.173,1.384 4.77,2.202 7.549,2.202" />
        </g> // eslint-disable-line
      );
    case 'twitter-logo':
      return (
        <g>
          <defs>
            <path
              id="SVGID_1_"
              d="M1024,199.4c-37.7,16.5-78.1,27.5-120.6,32.5c43.4-25.6,76.6-66.1,92.4-114.4
                c-40.6,23.7-85.6,41-133.5,50.2c-38.3-40.2-92.9-65.3-153.3-65.3c-116,0-210,92.6-210,206.8c0,16.2,1.9,31.9,5.4,47.1
                c-174.6-8.6-329.4-91-433-216.1c-18.1,30.5-28.5,66.1-28.5,104c0,71.7,37.2,135,93.5,172.1c-34.4-1.1-66.8-10.4-95.2-25.9
                c0,0.9,0,1.7,0,2.6c0,26.5,5.2,51.7,14.4,75c25.7,64.9,83.4,113.8,154.2,127.9c-17.7,4.7-36.2,7.3-55.4,7.3
                c-13.5,0-26.6-1.3-39.5-3.8c26.8,82.1,104.4,142,196.3,143.6c-71.9,55.5-162.5,88.6-260.9,88.6c-17,0-33.7-1-50.2-2.9
                c93,58.7,203.5,92.9,322.1,92.9c328.4,0,530.2-227.5,583.5-463.5c9.4-41.7,14.3-83.7,14.3-124.8c0-8.9-0.2-17.9-0.6-26.7
                C960.3,277.3,995.9,240.9,1024,199.4"
            />
          </defs>
          <clipPath id="SVGID_2_">
            <use href="#SVGID_1_" style={{ overflow: 'visible' }} />
          </clipPath>
          <rect
            x="-227.4"
            y="-124.9"
            className="st0"
            style={{ clipPath: 'url(#SVGID_2_)' }}
            width="1478.7"
            height="1273.9"
          />
        </g>
      );
    case 'user':
      return (
        <g>
          <path
            id="icon-me"
            d="M12.022,13.452c3.187,0 5.77,-2.857 5.77,-6.383c0,-3.526 -2.583,-6.384 -5.77,-6.384c-3.187,0 -5.771,2.858 -5.771,6.384c0,3.526 2.584,6.383 5.771,6.383Zm6.351,0.247c-0.233,-0.15 -0.536,-0.109 -0.742,0.075c-1.489,1.326 -3.455,2.131 -5.609,2.131c-2.155,0 -4.121,-0.805 -5.609,-2.131c-0.207,-0.184 -0.51,-0.225 -0.742,-0.075c-3.23,2.079 -5.372,5.686 -5.367,9.8c0,0.107 0.09,0.197 0.199,0.197l23.038,0c0.108,0 0.198,-0.09 0.198,-0.197c0.006,-4.114 -2.136,-7.721 -5.366,-9.8Z"
          />
        </g>
      );
    case 'user-unfilled':
      return (
        <g>
          <path
            id="path-1"
            d="M12.072,0.705c2.491,0 4.509,2.019 4.509,4.509c0,2.491 -2.018,4.51 -4.509,4.51c-1.196,0 -2.343,-0.475 -3.188,-1.321c-0.846,-0.846 -1.321,-1.993 -1.321,-3.189c0,-2.49 2.019,-4.509 4.509,-4.509Zm-0.002,11.273c-5.603,0 -10.143,4.361 -10.143,9.736c0.002,0.369 0,1.537 0,1.537c0,0 0.319,-0.007 0.558,0l19.17,0c0.24,-0.005 0.563,0 0.563,0c0,0 -0.002,-1.168 0,-1.537c-0.005,-5.379 -4.545,-9.736 -10.148,-9.736Z"
          />
        </g> // eslint-disable-line
      );
    case 'view-day':
      return (
        <g>
          <path d="M2 21h19v-3h-19v3zm18-13h-17c-.55 0-1 .45-1 1v6c0 .55.45 1 1 1h17c.55 0 1-.45 1-1v-6c0-.55-.45-1-1-1zm-18-5v3h19v-3h-19z" />
        </g> // eslint-disable-line
      );
    case 'video-collection':
      return (
        <g>
          <path d="M4 6H2v14c0 1.1.9 2 2 2h14v-2H4V6zm16-4H8c-1.1 0-2 .9-2 2v12c0 1.1.9 2 2 2h12c1.1 0 2-.9 2-2V4c0-1.1-.9-2-2-2zm-8 12.5v-9l6 4.5-6 4.5z" />
        </g> // eslint-disable-line
      );
    case 'vpn-key':
      return (
        <g>
          <path d="M12.65 10c-.82-2.33-3.04-4-5.65-4-3.31 0-6 2.69-6 6s2.69 6 6 6c2.61 0 4.83-1.67 5.65-4h4.35v4h4v-4h2v-4h-10.35zm-5.65 4c-1.1 0-2-.9-2-2s.9-2 2-2 2 .9 2 2-.9 2-2 2z" />
        </g> // eslint-disable-line
      );
    case 'youtube':
      return (
        <g>
          <defs>
            <path
              id="SVGID_5_"
              d="M1013.7,298.5c0,0-10-73.6-40.6-106c-38.9-42.5-82.6-42.7-102.5-45.2c-143.4-10.7-358.3-10.7-358.3-10.7
				h-0.5c0,0-215,0-358.2,10.8c-20,2.4-63.6,2.7-102.6,45.2c-30.6,32.4-40.6,106-40.6,106S0,384.9,0,471.3v81
				c0,86.5,10.3,172.9,10.3,172.9s10,73.6,40.6,106c39,42.5,90.2,41.2,112.9,45.6C245.7,885,512,887.6,512,887.6
				s215.1-0.4,358.5-11.1c19.9-2.5,63.6-2.7,102.5-45.3c30.7-32.4,40.6-105.9,40.6-105.9s10.3-86.4,10.3-172.9v-81
				C1024,384.9,1013.7,298.5,1013.7,298.5z M682.9,501.1L406.3,650.5l-0.1-230v-69.9L682.9,501.1z"
            />
          </defs>
          <clipPath id="SVGID_6_">
            <use href="#SVGID_5_" style={{ overflow: 'visible' }} />
          </clipPath>
          <rect
            x="-239.4"
            y="-102.9"
            className="st0"
            style={{ clipPath: 'url(#SVGID_6_)' }}
            width="1502.9"
            height="1229.8"
          />
        </g>
      );
    default:
      return <g />;
  }
};

const Icon = ({
  ariaHidden = false,
  ariaLabel = null,
  color = null,
  icon,
  role = 'button',
  size = null,
  viewBox = null,
}) => {
  const classes = classNames({
    [Style.icon]: icon,
    [Style[size]]: size,
    [Style[color]]: color,
  });
  const igStyle = {
    clipPath: 'url(#SVGID_3_)',
  };
  return (
    <svg
      className={classes}
      viewBox={viewBox || '0 0 24 24'}
      preserveAspectRatio="xMidYMid meet"
      data-testid={`${icon}-icon`}
      aria-label={ariaLabel}
      aria-hidden={ariaHidden}
      role={role}
      focusable="true"
    >
      {renderGraphic(icon, igStyle)}
    </svg>
  );
};

Icon.propTypes = {
  ariaLabel: PropTypes.string,
  ariaHidden: PropTypes.bool,
  icon: PropTypes.string.isRequired,
  color: PropTypes.oneOf([
    'inherit',
    'black',
    'greydarker',
    'greydark',
    'grey',
    'greylight',
    'greylighter',
    'white',
    'white25',
    'white50',
    'blue',
    'green',
    'orange',
    'purple',
    'red',
    'turquoise',
    'yellow',
  ]),
  role: PropTypes.string,
  size: PropTypes.oneOf(['small', 'medium', 'medium-large', 'large', 'full']),
  viewBox: PropTypes.string,
};

Icon.defaultProps = {
  ariaLabel: undefined,
  ariaHidden: undefined,
  color: null,
  role: 'button',
  viewBox: null,
  size: undefined,
};

export default React.memo(Icon);
